import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

/* eslint-disable sonarjs/function-name */
export const RenderPage = (elementId: string, app: React.ReactElement) => {
  const root = ReactDOM.createRoot(
    document.getElementById(elementId) as HTMLElement,
  );
  root.render(app);
  reportWebVitals();
};
